'use client';
import { motion } from 'framer-motion';

import { publicAssets } from 'utils/gcs';

const CircularProgress = () => {
  const RADIUS = 50;
  const STROKE_WIDTH = 0.75;
  const circumference = 2 * Math.PI * RADIUS;
  const adjustedRadius = RADIUS - STROKE_WIDTH / 2;

  return (
    <svg viewBox="0 0 100 100">
      <defs>
        <pattern
          id="gradient"
          patternUnits="userSpaceOnUse"
          width="100%"
          height="100%"
          patternTransform="rotate(90)"
        >
          <image
            href={publicAssets('/gradients/circle-gradient.png')}
            width="100"
            height="100"
          />
        </pattern>
      </defs>
      <motion.circle
        cx={RADIUS}
        cy={RADIUS}
        r={adjustedRadius}
        fill="none"
        stroke="url(#gradient)"
        strokeWidth={STROKE_WIDTH}
        strokeDasharray={circumference}
        initial={{ rotate: -90, strokeDashoffset: circumference }}
        animate={{
          rotate: [-90, 270],
          strokeDashoffset: [circumference, 0, -circumference],
        }}
        transition={{
          strokeDashoffset: {
            duration: 10,
            ease: 'linear',
            repeat: Infinity,
            repeatType: 'loop',
          },
          rotate: {
            duration: 10,
            ease: 'linear',
            repeat: Infinity,
            repeatType: 'loop',
          },
        }}
        style={{
          transformOrigin: '50% 50%',
          willChange: 'auto',
        }}
      />
    </svg>
  );
};

export default CircularProgress;
